import _, {includes, lowerCase} from 'lodash';

/**
 * Like ruby's "foo.presence || default", but using lodash's _isEmpty
 * so it doesn't choke on zeroes, empty hashes, etc.
 * (I really struggled to name this one)
 *
 * @param thing
 * @param deflt
 * @returns {*}
 */
export function presenceOr(thing, deflt) {
  return _.isEmpty(thing) ? deflt : thing;
}

export function isTruthy(thing) {
  if (thing === true)
    return true;

  let str = lowerCase("" + thing);
  return includes(["true", "1", "yes", "on"], str);
}
